import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About Me`}</h2>
    <h4>{`Hello! I'm Deepak Gour, a web developer based in Bhopal, MP.`}</h4>
    <p>{`I enjoy creating things that live on the internet, wheather that be websites, application,
or anything in between. `}</p>
    <p>{`My goal is to always build products that provide performant experiences.`}</p>
    <p>{`Shortly after graduated from RGPV University, I joined coaching institute as a Math teacher. And after that
I decided to learn about website Development. `}</p>
    <p>{`Here are the few technologies I've been working with recently: `}</p>
    <blockquote>
      <blockquote parentName="blockquote">
        <p parentName="blockquote">{`Javascript,
React,
Node.js,
MongoDB,
HTML & (S)CSS`}</p>
      </blockquote>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      